import { Component, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { Urls } from "../../../utils/urls";
import { ApiService } from "../../../shared/services/api.service";
import { CommonDataService } from "../../../shared/services/common-data.service";
import { Something_went_wrong, Thank_You } from "@root/app.constant";
import { NgForm } from '@angular/forms'; 
@Component({
  selector: "app-call-back",
  templateUrl: "./call-back.component.html",
  styleUrls: ["./call-back.component.scss"],
})
export class CallBackComponent implements OnInit {
  userData: any = {};
  firstName!: string;
  lastName!: string;
  cityList = [];
  mobNumberPattern = "^((\\+91-?)|0)?[6-9][0-9]{9}$";
  alphaPattern = "^[a-zA-Z ]*$";
  firstNamePattern = "^[a-zA-Z]*$";
  msgPattern = "^[a-zA-Z\\,\\.\\_\\;\\- ]*$";

  constructor(
    public activeModal: NgbActiveModal,
    public apiService: ApiService,
    private toastr: ToastrService,
    public commonDataService: CommonDataService
  ) { }

  ngOnInit() {
  }

  processForm = () => {
    this.userData.name = this.firstName + " " + this.lastName;
    this.apiService
      .postData(
        Urls.postRequestCallBack,
        this.commonDataService.convertToString(this.userData)
      )
      .subscribe((response: any) => {
        if (response.status === 0) {
          this.toastr.success(
            Thank_You
          );
        } else {
          this.toastr.error(Something_went_wrong);
        }
        this.activeModal.close();
      });
  };

  onSubmit(form: NgForm): void {

  if (form.invalid) {
    this.focusFirstInvalidField();
    return;
  }

  this.processForm();
}

  closePopUp = () => {
    this.activeModal.close();
  };
  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  focusFirstInvalidField(): void {
  const firstInvalid = document.querySelector(
    'input.ng-invalid, select.ng-invalid, textarea.ng-invalid'
  ) as HTMLElement;

  if (firstInvalid) {
    firstInvalid.focus();
  }
}
}
